import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import axios from "axios";
import Logo from "../components/Logo";
import { LOGO_AUTH_CALLBACK } from "../config/logoSizes";
import { useApp } from "../context/AppContext";
import { addNotification } from "../utils/notifications";
const isMobileUa = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");
const AuthCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useApp();
  const token = params.get("token");
  const isNewUser = params.get("isNew") === "1";
  const [mode, setMode] = useState("loading");
  useEffect(() => {
    if (!token) {
      navigate("/signin", { replace: true });
      return;
    }
    let cancelled = false;
    const run = async () => {
      localStorage.setItem("auth_token", token);
      try {
        await axios.post("/api/auth/set-cookie", { token });
      } catch {
      }
      try {
        await checkAuth();
        const planType = params.get("plan");
        if (planType === "hourly" || planType === "monthly") {
          addNotification({
            type: "plan_upgrade",
            titleAr: "\u062A\u0645\u062A \u062A\u0631\u0642\u064A\u0629 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0628\u0646\u062C\u0627\u062D",
            titleEn: "Plan upgraded successfully",
            bodyAr: planType === "monthly" ? "\u0644\u0642\u062F \u0627\u0634\u062A\u0631\u0643\u062A \u0641\u064A \u0628\u0627\u0642\u0629 Pro \u2014 \u0627\u0633\u062A\u0645\u062A\u0639 \u0628\u062A\u0641\u0633\u064A\u0631 \u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F." : "\u0644\u0642\u062F \u0627\u0634\u062A\u0631\u064A\u062A \u062C\u0644\u0633\u0629 \u0628\u0627\u0644\u0633\u0627\u0639\u0629 \u2014 \u0627\u0633\u062A\u0645\u062A\u0639 \u0628\u0627\u0644\u062A\u0641\u0633\u064A\u0631 \u0627\u0644\u0622\u0646.",
            bodyEn: planType === "monthly" ? "You subscribed to the Pro plan \u2014 enjoy unlimited interpretation." : "You purchased an hourly session \u2014 start interpreting now."
          });
        }
      } catch {
      }
      if (cancelled) return;
      const native = Capacitor.isNativePlatform();
      const mobileBrowser = !native && isMobileUa();
      const dest = isNewUser ? "/welcome" : "/chat";
      if (native) {
        setMode("redirecting");
        navigate(dest, { replace: true });
        return;
      }
      if (!mobileBrowser) {
        setMode("redirecting");
        navigate(dest, { replace: true });
        return;
      }
      setMode("choose");
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [token, isNewUser, navigate, checkAuth, params]);
  const openInApp = () => {
    if (!token) return;
    window.location.href = `taweelai://callback?token=${encodeURIComponent(token)}`;
  };
  const continueInBrowser = () => {
    setMode("redirecting");
    navigate(isNewUser ? "/welcome" : "/chat", { replace: true });
  };
  if (mode === "loading" || mode === "redirecting") {
    return <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "var(--bg-base)", gap: 16, padding: "max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left))" }}>
        <Logo variant="full" size={LOGO_AUTH_CALLBACK} />
        <p style={{ color: "var(--text-2)", fontFamily: "Outfit,sans-serif", fontSize: 14 }}>
          {mode === "redirecting" ? "\u062C\u0627\u0631\u064A \u0627\u0644\u062F\u062E\u0648\u0644\u2026" : "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644\u2026"}
        </p>
        <div className="spinner" style={{ width: 24, height: 24 }} />
      </div>;
  }
  return <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "var(--bg-base)", gap: 20, padding: "max(24px, env(safe-area-inset-top)) max(24px, env(safe-area-inset-right)) max(24px, env(safe-area-inset-bottom)) max(24px, env(safe-area-inset-left))" }}>
      <Logo variant="full" size={LOGO_AUTH_CALLBACK} />
      <div style={{ textAlign: "center" }}>
        <h2 style={{ color: "var(--text-1)", fontFamily: "Outfit,sans-serif", fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
          تم تسجيل الدخول بنجاح
        </h2>
        <p style={{ color: "var(--text-2)", fontSize: 13, marginBottom: 8, lineHeight: 1.6 }}>
          اختر: فتح التطبيق أو المتابعة في المتصفح
        </p>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12, width: "100%", maxWidth: 320 }}>
        <button
    type="button"
    onClick={openInApp}
    style={{
      padding: "14px 24px",
      background: "var(--accent)",
      color: "#fff",
      border: "none",
      borderRadius: 12,
      cursor: "pointer",
      fontFamily: "Outfit,sans-serif",
      fontSize: 15,
      fontWeight: 700,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8
    }}
  >
          فتح TaweelAI في التطبيق
        </button>
        <button
    type="button"
    onClick={continueInBrowser}
    style={{
      padding: "12px 24px",
      background: "transparent",
      color: "var(--text-2)",
      border: "1px solid var(--border2)",
      borderRadius: 12,
      cursor: "pointer",
      fontFamily: "Outfit,sans-serif",
      fontSize: 14
    }}
  >
          المتابعة في المتصفح
        </button>
      </div>
    </div>;
};
var stdin_default = AuthCallback;
export {
  stdin_default as default
};
